import { getConfig } from './config'

const config = getConfig()

export const widgetSettings = { widgetWidth: '300', widgetHeight: '300' }
export const notificationDelayTimer = 1500
export const sizeInBytes = 1048576
export const loginScreenTitle = 'Centrali'
export const loginScreenSubTitle = "Let's get started by setting up your account"
export const accountInfo = 'Account Information'
export const accountInfoAccDetails = 'Enter your account details'
export const personalInfoDetails =
  'Please answer the question below to get the best experience on Centrali'
export const staticAssetsPath = config.STATIC_ASSETS_URL
export const starterKitLink =
  'https://investmenttransformation.visualstudio.com/Analytics%20Platform/_git/AP.Analytics.Portal.StarterKit'
export const docusaurus = 'https://centralios.mandg.com/'
export const dsm = 'https://as-mg-dev1-t1-weu-invdesktop-dsm-01.azurewebsites.net/dashboard/home'
export const contactEmail = 'MandGAnalyticsmailbox@MandG.co.uk'
export const mgsite = 'https://savingsandinvestments.sharepoint.com/sites/mandg'
export const cSharpKit =
  'https://dev.azure.com/investmenttransformation/Analytics%20Platform/_git/Autocode.NET'
export const centraliUserGuides =
  'https://mandg.atlassian.net/wiki/spaces/InvAn/pages/37260062/Centrali+User+Guide'
export const releaseNotes =
  'https://savingsandinvestments.sharepoint.com/sites/Automation303/SitePages/Centrali-Release-Notes.aspx'
export const excelFileType =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
export const AliVideo =
  'https://savingsandinvestments.sharepoint.com/sites/MGAnalytics551/_layouts/15/embed.aspx?UniqueId=3cab4e28-5f44-488f-a69c-926e89bf0a45&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=OneUpFileViewer&referrerScenario=EmbedDialog.Create'
export const workspaceVideo =
  'https://savingsandinvestments.sharepoint.com/sites/MGAnalytics551/_layouts/15/embed.aspx?UniqueId=068b266f-fe18-4c0b-96f9-6ad43af52b7c&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create'
export const workspaceGuide =
  'https://savingsandinvestments.sharepoint.com/:b:/r/sites/MGAnalytics551/SiteAssets/Centrali/Workspace%202.0%20Guide.pdf?csf=1&web=1&e=vgGcIA'
export const centraliGuides =
  'https://savingsandinvestments.sharepoint.com/:u:/r/sites/dep-operations/SitePages/Centrali-User-Guides.aspx?csf=1&web=1&e=KvjNPR'
export const uatUrl = 'https://centrali.uat.mandg.com'
export const centraliPromo =
  'https://savingsandinvestments.sharepoint.com/sites/MGAnalytics551/_layouts/15/embed.aspx?UniqueId=738d6843-f851-45d1-8dbd-bb14b0decb93&embed=%7B%22ust%22%3Afalse%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create'
export const centrali3_0 =
  'https://savingsandinvestments.sharepoint.com/sites/MGAnalytics551/_layouts/15/embed.aspx?UniqueId=637b2950-a7dc-41dd-94ec-8e35b761f3a6&embed=%7B%22ust%22%3Afalse%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create'
export const FAQPage =
  'https://savingsandinvestments.sharepoint.com/sites/Automation303/SitePages/FAQ-%26-Troubleshooting-Guide.aspx?ct=1783005261520&or=Teams-HL&ga=1'

export const APP = {
  NAME: 'App name',
  SHORT_DESCRIPTION: 'Plan Your Day perfectly, Notes taking, Reminders'
}

export const MANDG_GDPR_REVIEWS =
  'By submitting this review you are aware and agree to your review and name being shared with M&G employees'

export const ARC_ROLE_REQUEST_TITLE = `Access permission requested for `

export const WORKSPACE_APPLICATION_HEADLINES = {
  RECENTLY_OPEN_HEADLINE: 'You have recently opened these apps',
  FAVOURITE_APPS_HEADLINE: 'Favourites',
  MY_APPS_HEADLINE: 'My apps',
  COLLECTIONS_HEADLINE: 'My collections'
}

export const toolbarOptions = {
  options: [
    'inline',
    'blockType',
    'fontSize',
    'list',
    'textAlign',
    'colorPicker',
    'link',
    'emoji',
    'remove',
    'history'
  ]
}

export const editorConfig = {
  ADD_ATTR: ['target']
}

export const ItemTypes = {
  PROMPT: 'prompt'
}

export const HIDE_DATA_PREVIEW_FILTERS = true
